import React from 'react';
import { Form, FormInstance, Input, InputNumber, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import FormSection from 'components/ui/form-section';
import FormLayoutGroup from 'components/ui/form-layout-group';
import { formatLocaleNumber } from 'utils/format';
import { useWatch } from 'antd/es/form/Form';
import {
  ContractResponseDtoContractStatusEnum,
  ContractResponseDtoNtuReasonEnum,
} from 'libs/pinnacle-sdk';
import { ArrowDownIcon } from 'assets/icons/arrow-down';
import { SortedSelect } from 'components/ui/sorted-select';

const { TextArea } = Input;

interface ClosingReasonSectionProps {
  disabled?: boolean;
  form: FormInstance;
}

const ClosingReasonSection: React.FC<ClosingReasonSectionProps> = ({
  disabled = false,
  form,
}) => {
  const { t } = useTranslation();
  const contractStatus = useWatch('contractStatus', form);

  return (
    <FormSection
      title={t('contractDetail.provideReasonForClosingCase')}
      collapsible
    >
      <FormLayoutGroup
        mdColumns={
          contractStatus === ContractResponseDtoContractStatusEnum.NotTakenUp
            ? 3
            : 2
        }
      >
        <Form.Item
          name="ntuReason"
          label={t('contractDetail.ntuReason')}
          hidden={
            contractStatus !== ContractResponseDtoContractStatusEnum.NotTakenUp
          }
        >
          <SortedSelect
            options={Object.values(ContractResponseDtoNtuReasonEnum).map(
              (reason) => ({
                label: reason,
                value: reason,
              })
            )}
            size="large"
            suffixIcon={<ArrowDownIcon />}
            disabled={disabled}
            placeholder={t('general.selectField', {
              field: t('contractDetail.ntuReason'),
            })}
          />
        </Form.Item>
        <Form.Item
          label={t('contractDetail.competitorRateOnLine')}
          name="competitorRateOnLine"
        >
          <InputNumber
            className="w-full"
            size="large"
            addonAfter="%"
            step="0.01"
            placeholder={t('contractDetail.competitorRateOnLine')}
            disabled={disabled}
            formatter={(value) => formatLocaleNumber(Number(value))}
          />
        </Form.Item>

        <Form.Item
          label={t('contractDetail.competitorRateOnExposure')}
          name="competitorRateOnExposure"
        >
          <InputNumber
            className="w-full"
            size="large"
            addonAfter="%"
            step="0.01"
            placeholder={t('contractDetail.competitorRateOnExposure')}
            disabled={disabled}
            formatter={(value) => formatLocaleNumber(Number(value))}
          />
        </Form.Item>
      </FormLayoutGroup>

      <FormLayoutGroup mdColumns={1}>
        <Form.Item
          label={t('contractDetail.pleaseStateYourReason')}
          name="closingReason"
        >
          <TextArea
            rows={6}
            size="large"
            placeholder={t('contractDetail.addYourReasonHere')}
            disabled={disabled}
          />
        </Form.Item>
      </FormLayoutGroup>
    </FormSection>
  );
};

export default ClosingReasonSection;
